import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { OLD_PRICE, PRICE } from '../data/religia';
const recap = ['6 tomów', '5 bonusów', '12 lekcji minuta po minucie', 'Klasy 1–8'];
const reassurances = ['Natychmiastowy dostęp do pobrania', 'PDF do druku', '7 dni gwarancji satysfakcji'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-104" data-mp="15fq8oahibe7o">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-105" data-mp="1jb25cnf83er8" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-106" data-mp="1t2om0zaby61d">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-107" data-mp="1t510v3ksk0a7">
          Twoje lekcje religii mogą być <em className="text-red-700" data-id="element-108" data-mp="22339a46utv7i">gotowe już dziś.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-109" data-mp="2219zig0y2uva">
          Zamiast co miesiąc szukać nowych materiałów, pisać każdą kartę pracy od nowa i spędzać
          wieczory nad konspektem, masz uporządkowany pakiet na cały rok szkolny. Więcej czasu na to, co
          naprawdę ważne:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-110" data-mp="x38yfqdjfs3s">
          Twoi uczniowie. Twoja klasa. Twoje życie poza szkołą.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-111" data-mp="120ion88r47so">
          {recap.map(item => <li key={item} data-id="element-112" data-mp="1b2rtpil938yo">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-2xl leading-none text-slate-900/50" data-id="element-113" data-mp="1b1gr3m3jk795">
          <span className="sr-only" data-id="element-114" data-mp="1furyppg6gs24">Cena regularna: </span>
          <s data-id="element-115" data-mp="1ktwcyuhylfzb">{OLD_PRICE}</s>
        </p>
        <p className="mt-3 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-116" data-mp="1ksth085s4ncj">
          <span className="sr-only" data-id="element-117" data-mp="1puaia4s6ebtn">Cena teraz: </span>
          {PRICE}
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-118" data-mp="1tuudh2t6v5d5">Jednorazowa płatność – bez subskrypcji.</p>

        <div className="mt-8 flex justify-center" data-id="element-119" data-mp="3qvgp9vdi69ae">
          <CtaButton className="w-full sm:w-auto" data-id="element-120" data-mp="3lvuertp2775a" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-121" data-mp="3lxf6zcnwidzz">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-122" data-mp="3uwityrq6vdjr">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-123" data-mp="3uuzdp14j92hz" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}